import { render, staticRenderFns } from "./CustomerOldDialog.vue?vue&type=template&id=3d35f75a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./CustomerOldDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerOldDialog.vue?vue&type=script&lang=ts"
import style0 from "./CustomerOldDialog.vue?vue&type=style&index=0&id=3d35f75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d35f75a",
  null
  
)

export default component.exports